import Registry from './Registry';

/**
 * Synchronous registry
 */
export default class SyncRegistry<V> extends Registry<V, V> {}
